var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5, _path6, _path7, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeloitte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27",
    "data-name": "Group 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.012,
    height: 14.96,
    viewBox: "0 0 80.012 14.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M102.291,16.556a2.083,2.083,0,1,1,2.082,2.132,2.109,2.109,0,0,1-2.082-2.132",
    transform: "translate(-26.443 -3.728)",
    fill: "#7db72c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 3.686,
    height: 2.465,
    transform: "translate(42.233 0.001)",
    fill: "#1a1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M8.139,7.244a4.744,4.744,0,0,0-.779-2.988A2.846,2.846,0,0,0,5,3.283H3.869V11.5h.862a3.082,3.082,0,0,0,2.586-1.048,5.152,5.152,0,0,0,.823-3.2M12.155,7.1a7.681,7.681,0,0,1-1.974,5.656,7.474,7.474,0,0,1-5.549,1.986H0V.083H4.956A7.37,7.37,0,0,1,10.28,1.889,6.908,6.908,0,0,1,12.155,7.1",
    transform: "translate(0 -0.021)",
    fill: "#1a1818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.686,
    height: 14.725,
    transform: "translate(24.987 0)",
    fill: "#1a1818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M44.346,10.486a4.955,4.955,0,0,0,.368,2.147,1.273,1.273,0,0,0,1.235.739,1.239,1.239,0,0,0,1.212-.739,5.134,5.134,0,0,0,.353-2.147,4.873,4.873,0,0,0-.357-2.114,1.4,1.4,0,0,0-2.442-.005,4.755,4.755,0,0,0-.368,2.119m6.919,0a5.871,5.871,0,0,1-1.409,4.184,5.147,5.147,0,0,1-3.945,1.5,5.045,5.045,0,0,1-3.87-1.536,5.825,5.825,0,0,1-1.438-4.15,5.791,5.791,0,0,1,1.41-4.157,5.2,5.2,0,0,1,3.955-1.482,5.524,5.524,0,0,1,2.781.686A4.626,4.626,0,0,1,50.61,7.5a6.463,6.463,0,0,1,.655,2.987",
    transform: "translate(-10.496 -1.253)",
    fill: "#1a1818"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 3.686,
    height: 10.938,
    transform: "translate(42.233 3.787)",
    fill: "#1a1818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M69.908,12.057a5.359,5.359,0,0,0,1.782-.377v2.752a7.143,7.143,0,0,1-1.418.467,7.78,7.78,0,0,1-1.579.141,3.406,3.406,0,0,1-2.678-.932,4.244,4.244,0,0,1-.819-2.861V6.737H63.9V3.909h1.291V1.117L68.909.47V3.909h2.352V6.737H68.909v4.258q0,1.061,1,1.062",
    transform: "translate(-16.52 -0.121)",
    fill: "#1a1818"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M81.414,12.057a5.363,5.363,0,0,0,1.782-.377v2.752a7.127,7.127,0,0,1-1.418.467,7.78,7.78,0,0,1-1.579.141,3.4,3.4,0,0,1-2.677-.932,4.24,4.24,0,0,1-.82-2.861V6.737H75.409V3.909H76.7V1.074l3.714-.6V3.909h2.353V6.737H80.416v4.258q0,1.061,1,1.062",
    transform: "translate(-19.494 -0.121)",
    fill: "#1a1818"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M90.859,9.153a2,2,0,0,1,.514-1.318,1.512,1.512,0,0,1,1.089-.42,1.426,1.426,0,0,1,1.126.473,1.9,1.9,0,0,1,.438,1.264Zm5.2-3.016a5.1,5.1,0,0,0-3.727-1.289,5.048,5.048,0,0,0-3.9,1.482,6.05,6.05,0,0,0-1.367,4.252,5.549,5.549,0,0,0,1.476,4.137,5.656,5.656,0,0,0,4.144,1.453A12.119,12.119,0,0,0,94.885,16a6.358,6.358,0,0,0,1.78-.622L96.1,12.911a7.886,7.886,0,0,1-1.191.389,7.939,7.939,0,0,1-1.786.188,2.524,2.524,0,0,1-1.683-.521,1.9,1.9,0,0,1-.655-1.438h6.59V9.849a4.966,4.966,0,0,0-1.315-3.712",
    transform: "translate(-22.506 -1.253)",
    fill: "#1a1818"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M21.666,9.153a1.994,1.994,0,0,1,.513-1.318,1.513,1.513,0,0,1,1.089-.42,1.429,1.429,0,0,1,1.126.473,1.909,1.909,0,0,1,.438,1.264Zm5.2-3.016a5.1,5.1,0,0,0-3.728-1.289,5.044,5.044,0,0,0-3.9,1.482,6.05,6.05,0,0,0-1.367,4.252,5.546,5.546,0,0,0,1.476,4.137,5.653,5.653,0,0,0,4.143,1.453A12.114,12.114,0,0,0,25.691,16a6.358,6.358,0,0,0,1.78-.622l-.566-2.464a7.914,7.914,0,0,1-1.191.389,7.95,7.95,0,0,1-1.786.188,2.522,2.522,0,0,1-1.682-.521,1.89,1.89,0,0,1-.655-1.438H28.18V9.849a4.963,4.963,0,0,0-1.315-3.712",
    transform: "translate(-4.619 -1.253)",
    fill: "#1a1818"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 80.012,
    height: 14.959,
    transform: "translate(0 0.001)",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeloitte);
export default __webpack_public_path__ + "static/media/deloitte.a134dc5c6fc08ff9351f7f3b3622b82b.svg";
export { ForwardRef as ReactComponent };